module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-information-settings"
  }, [_c('div', {
    staticClass: "row mx-0 mb-2"
  }, [_c('div', {
    staticClass: "col-12 col-md-6 px-0"
  }, [_c('Button', {
    attrs: {
      "disabled": false,
      "isLoading": false
    },
    on: {
      "click": function($event) {
        return _vm.showModal()
      }
    }
  }, [_vm._v("Добавить место учёбы")])], 1)]), _c('div', {
    staticClass: "row mx-0 mb-2"
  }, [(!_vm.study.length) ? _c('div', {
    staticClass: "col-12 d-flex flex-column px-0 mb-2"
  }, [_c('h3', {
    staticClass: "profile-information-settings_type-title mb-4 mt-4"
  }, [_vm._v("Нет информации о местах учебы")])]) : _vm._e(), _vm._l((_vm.educationTypeDict), function(educationType, iIndex) {
    return (_vm.study.filter(function (el) { return el.education_type === educationType.id; }).length) ? _c('div', {
      key: iIndex,
      staticClass: "col-12 d-flex flex-column px-0 mb-2"
    }, [_c('h3', {
      staticClass: "profile-information-settings_type-title mb-4 mt-4"
    }, [_vm._v(_vm._s(educationType.name))]), _vm._l((_vm.study.filter(function (el) { return el.education_type === educationType.id; })), function(studyPlace, jIndex) {
      return _c('div', {
        key: JSON.stringify(jIndex),
        staticClass: "row mx-0 px-3 py-3 profile-information-settings_card-item mb-3",
        staticStyle: {
          "row-gap": "16px"
        }
      }, [_vm._m(0, true), _c('div', {
        staticClass: "col-md-6 col-12 d-flex flex-column"
      }, [_c('span', {
        staticClass: "profile-information-settings_item"
      }, [_vm._v(_vm._s(studyPlace.id))])]), (studyPlace && studyPlace.education_level) ? _c('div', {
        staticClass: "col-md-4 col-12 d-flex flex-column"
      }, [_c('span', {
        staticClass: "profile-information-settings_item--bold"
      }, [_vm._v("Уровень образования")])]) : _vm._e(), (studyPlace && studyPlace.education_level) ? _c('div', {
        staticClass: "col-md-6 col-12 d-flex flex-column"
      }, [_c('span', {
        staticClass: "profile-information-settings_item"
      }, [_vm._v(_vm._s(_vm.educationLevelDict.find(function (el) { return el.id == Number(studyPlace.education_level); }).name))])]) : _vm._e(), (studyPlace && studyPlace.course_name) ? _c('div', {
        staticClass: "col-md-4 col-12 d-flex flex-column"
      }, [_c('span', {
        staticClass: "profile-information-settings_item--bold"
      }, [_vm._v("Название курса")])]) : _vm._e(), (studyPlace && studyPlace.course_name) ? _c('div', {
        staticClass: "col-md-6 col-12 d-flex flex-column"
      }, [_c('span', {
        staticClass: "profile-information-settings_item"
      }, [_vm._v(_vm._s(studyPlace.course_name))])]) : _vm._e(), (studyPlace && studyPlace.study_place) ? _c('div', {
        staticClass: "col-md-4 col-12 d-flex flex-column"
      }, [_c('span', {
        staticClass: "profile-information-settings_item--bold"
      }, [_vm._v("Место учебы")])]) : _vm._e(), (studyPlace && studyPlace.study_place) ? _c('div', {
        staticClass: "col-md-6 col-12 d-flex flex-column"
      }, [_c('span', {
        staticClass: "profile-information-settings_item"
      }, [_vm._v(_vm._s(studyPlace.study_place))])]) : _vm._e(), (studyPlace && studyPlace.specialization) ? _c('div', {
        staticClass: "col-md-4 col-12 d-flex flex-column"
      }, [_c('span', {
        staticClass: "profile-information-settings_item--bold"
      }, [_vm._v("Специализация")])]) : _vm._e(), (studyPlace && studyPlace.specialization) ? _c('div', {
        staticClass: "col-md-6 col-12 d-flex flex-column"
      }, [_c('span', {
        staticClass: "profile-information-settings_item"
      }, [_vm._v(_vm._s(studyPlace.specialization))])]) : _vm._e(), _c('div', {
        staticClass: "col-md-4 col-12 d-flex flex-column"
      }, [_c('span', {
        staticClass: "profile-information-settings_item--bold"
      }, [_vm._v(_vm._s(studyPlace.year ? 'Год окончания' : 'Обучается'))])]), _c('div', {
        staticClass: "col-md-6 col-12 d-flex flex-column"
      }, [_c('span', {
        staticClass: "profile-information-settings_item"
      }, [_vm._v(_vm._s(studyPlace.year ? studyPlace.year : 'По настоящее время'))])]), _c('AppSvgIcon', {
        staticClass: "ui_color__red px-0 py-0 ui_cursor__pointer profile-information-settings_item-remove",
        attrs: {
          "template": _vm.$ui.IconSvgComponents.close,
          "color-mode": "stroke",
          "manual-width": "auto",
          "as-is-button": "as-is-button"
        },
        on: {
          "click": function($event) {
            return _vm.removeItem(studyPlace)
          }
        }
      })], 1)
    })], 2) : _vm._e()
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 col-12 d-flex flex-column"
  }, [_c('span', {
    staticClass: "profile-information-settings_item--bold"
  }, [_vm._v("ID")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-111683cc","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/study/Study.vue
// module id = e6518a11e9c31a276f6d
// module chunks = 29